import { store } from '@/context/store';

import { getRequiredDocuments } from '../getRequiredDocuments';

export function areAllRequiredDocsPresent(): boolean {
    const state = store.getState();
    const supportingDocs = state.borrowerReducer.supportingDocs;
    // Includes the brand's mandatory documents, not just the lender's.
    const requiredDocs = getRequiredDocuments();

    // Check if requiredDocs is defined
    if (!requiredDocs) {
        return false;
    }

    for (const key in requiredDocs) {
        // Check if the key in requiredDocs is present in supportingDocs
        if (!supportingDocs[key]) {
            return false; // A required document is missing
        }
    }

    return true; // All required documents are present
}
